<template>
<div >
    <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>  
      
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="accessTransactionLogs"
      :rows-per-page-items="[10, 25, 50, 100]"
      item-key="name"
      align-center
    >
      <template v-slot:items="props" >
          <td class="text-xs-center">{{props.item.description}}</td>
          <td class="text-xs-center">{{props.item.dateStamp}}</td> 
          <td class="text-xs-center">{{props.item.timeStamp}}</td>   
          <td v-if="(props.item.accessDevice.direction) != null && (props.item.accessDevice.direction) == true" class="text-xs-center">IN</td>   
          <td v-if="(props.item.accessDevice.direction) != null && (props.item.accessDevice.direction) == false" class="text-xs-center">OUT</td>   
          <td v-if="(props.item.accessDevice.direction) == null" class="text-xs-center">No Direction</td>  
            <td class="text-xs-center">{{props.item.accessDevice.accessPoint.name}}</td>    
            <td v-if="typeof(props.item.tag.tagCode) != 'undefined'" class="text-xs-center">{{props.item.tag.tagCode}}</td>    
          <td v-else class="text-xs-center">No Tag Code Assigned</td>   
            <td v-if="typeof(props.item.tag.biometricImage) != 'undefined'" class="text-xs-center">{{props.item.tag.biometricImage}}</td>    
          <td v-else class="text-xs-center">No Biometric Image</td>   
          <td v-if="typeof(props.item.tag.contact) != 'undefined'" class="text-xs-center">{{props.item.tag.contact.name}} {{props.item.tag.contact.surname}}</td>    
          <td v-else class="text-xs-center">No Contact Associated</td>        
    
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->
    
    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
export default {
  props:["accesstransactionlogscomponent",
         "accesstransactionlogsinfo"],
  data() {
    return {
    showDetails: true,
    isloading:true,
    loading: false, 
    expand: false,
    search: "",
    dialog: false,
    newDialog: false,
    pagination: { },
    headers: [
      {
        text: "Description",
        align: "center",
        value: "description"
      },
       {
        text: "Date Stamp",
        align: "center",
        value: "dateStamp"
      },
       {
        text: "Time Stamp",
        align: "center",
        value: "timeStamp"
      },
       {
        text: "Access Device Direction",
        align: "center",
        value: "accessDevice"
      },
       {
        text: "Access Point",
        align: "center",
        value: "accessPoint"
      },
       {
        text: "Tag Code",
        align: "center",
        value: "tagCode"
      },
       {
        text: "Biometric Image",
        align: "center",
        value: "biometricImage"
      },
       {
        text: "Contact",
        align: "center",
        value: "contact"
      }
    ],
    accessTransactionLogs: [],
    accessDevices: [],
    tags: [],
    editedIndex: -1,
    editedItem: {
        description: "",
        dateStamp: "",
        timeStamp: "",
        accessDeviceId: null,
        tagId: null
    },
    defaultItem: {
        description: "",
        dateStamp: "",
        timeStamp: "",
        accessDeviceId: null,
        tagId: null
    },
  }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
      search(value){
       const route= {
        search: this.$route.search
      }
       if ((this.search)){      
        route.query = {search: this.search}        
      }
      this.$router.push(route)      
    
    },
    '$route.query':{
      immediate: true,
      async handler(value){
        this.accessTransactionLogs= await this.searchTransactionLogs(value)
      }
    },
     '$route.query.search':{
      immediate: true,
      handler(value){
        this.search=value
      },
    }, 
  },
  created() {
    this.initialize();
  },
  methods: {
     searchTransactionLogs(search){
       this.isloading =true
      if(search.search!==""){   
         if(typeof(this.$route.params.tagId) != 'undefined'){

           Api()
        .get("/accessTransactionLogs/showByTag/" + this.$route.params.tagId,{
          params: {
          search: search.search,
         }
          })
        .then(response => {
          this.accessTransactionLogs = response.data;
          this.isloading =false
        });
         }
         else{
        Api()
        .get('/accessTransactionLogs/getall',{
          params: {
          search: search.search,
         }
          })
        .then(response=>{
          this.accessTransactionLogs=response.data
          this.isloading =false
        })
         }
        } 
      },
    fetchAccessTransactionLogs() {
        this.isloading =true
      Api()
        .get("/accessTransactionLogs/getall")
        .then(response => {
          this.accessTransactionLogs = response.data;
              for(let i=0; i<this.accessTransactionLogs.length; i++){
                if(this.accessTransactionLogs[i].accessDevice.direction ==false){
              this.accessTransactionLogs[i].description = this.accessTransactionLogs[i].tag.contact.name + " " + this.accessTransactionLogs[i].tag.contact.surname + " exited " + 
              this.accessTransactionLogs[i].accessDevice.accessPoint.name
                }
                 if(this.accessTransactionLogs[i].accessDevice.direction ==true){
              this.accessTransactionLogs[i].description = this.accessTransactionLogs[i].tag.contact.name + " " + this.accessTransactionLogs[i].tag.contact.surname + " entered " + 
              this.accessTransactionLogs[i].accessDevice.accessPoint.name
                }
                 if(this.accessTransactionLogs[i].accessDevice.direction ==null){
              this.accessTransactionLogs[i].description = this.accessTransactionLogs[i].tag.contact.name + " " + this.accessTransactionLogs[i].tag.contact.surname + " used " +
              this.accessTransactionLogs[i].accessDevice.accessPoint.name
                }
              }
          this.isloading =false
        });
    
      
    },
    fetchAccessDevices() {
        this.isloading =true
      Api()
        .get("/accessDevices/getall")
        .then(response => {
          this.accessDevices = response.data;
          this.isloading =false
        });
      
    },
    fetchTags() {
        this.isloading =true
      Api()
        .get("/tags/getall")
        .then(response => {
          this.tags = response.data;
          this.isloading =false
        });
      
    },
    initialize() {
      if(typeof(this.$route.params.tagId) == 'undefined'){
      this.fetchAccessTransactionLogs();
      }else{
        this.$emit('fetchLogs')
      }
      this.fetchAccessDevices();
      this.fetchTags();
    },

  }
};
</script>